import React from 'react'

export default function TreasuryBills() {
  return (
    <div>TreasuryBills</div>
  )
}
